import React, { useState, useRef } from "react";
import { FiMic, FiSquare, FiSend } from "react-icons/fi";

const VoiceRecorder = ({ onSend }) => {
  const [recording, setRecording] = useState(false);
  const [elapsed, setElapsed] = useState(0);
  const [audioBlob, setAudioBlob] = useState(null);
  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);
  const timerRef = useRef(null);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;
      chunksRef.current = [];

      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunksRef.current.push(e.data);
      };

      mediaRecorder.onstop = () => {
        const blob = new Blob(chunksRef.current, { type: "audio/webm" });
        setAudioBlob(blob);
        stream.getTracks().forEach((t) => t.stop());
      };

      mediaRecorder.start();
      setRecording(true);
      setElapsed(0);
      setAudioBlob(null);

      timerRef.current = setInterval(() => {
        setElapsed((prev) => prev + 1);
      }, 1000);
    } catch (err) {
      console.error("Mic access denied:", err);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current?.state === "recording") {
      mediaRecorderRef.current.stop();
    }
    clearInterval(timerRef.current);
    setRecording(false);
  };

  const handleCancel = () => {
    stopRecording();
    setAudioBlob(null);
    setElapsed(0);
  };

  const handleSend = () => {
    if (audioBlob) {
      const file = new File([audioBlob], `voice_${Date.now()}.webm`, { type: "audio/webm" });
      onSend(file);
      setAudioBlob(null);
      setElapsed(0);
    }
  };

  const formatTime = (s) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m}:${sec.toString().padStart(2, "0")}`;
  };

  if (audioBlob) {
    return (
      <div className="voice-recorder">
        <audio src={URL.createObjectURL(audioBlob)} controls style={{ height: 32, maxWidth: 160 }} />
        <button onClick={handleCancel} type="button" className="voice-recorder__cancel">
          Cancel
        </button>
        <button onClick={handleSend} type="button" className="voice-recorder__btn voice-recorder__btn--stop">
          <FiSend size={16} />
        </button>
      </div>
    );
  }

  if (recording) {
    return (
      <div className="voice-recorder">
        <button onClick={stopRecording} type="button" className="voice-recorder__btn voice-recorder__btn--recording">
          <FiSquare size={14} />
        </button>
        <span className="voice-recorder__timer">{formatTime(elapsed)}</span>
        <button onClick={handleCancel} type="button" className="voice-recorder__cancel">
          Cancel
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={startRecording}
      type="button"
      className="voice-recorder__btn voice-recorder__btn--idle"
      title="Record voice message"
    >
      <FiMic size={16} />
    </button>
  );
};

export default VoiceRecorder;
